import { apiClient } from './apiClient';

export type OverpaymentSetting = {
  id: number;
  name: string;
};

export const getOverpaymentSettings = (): Promise<OverpaymentSetting[]> =>
  apiClient.get('/overpayment-settings', {});
